// Thin fetch wrapper around the Worker API. Credentials: "include" so the
// Cf-Access-Jwt-Assertion header set by Access on the browser session is
// forwarded on admin calls.

const base = "";

async function call(path, opts = {}) {
  const res = await fetch(base + path, {
    credentials: "include",
    ...opts,
    headers: {
      ...(opts.body && !(opts.body instanceof FormData) ? { "Content-Type": "application/json" } : {}),
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`${res.status} ${res.statusText}: ${text}`);
  }
  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? res.json() : res.text();
}

export const api = {
  getSite: () => call("/api/site"),

  // sections
  createSection: (title) =>
    call("/api/admin/sections", { method: "POST", body: JSON.stringify({ title }) }),
  patchSection: (id, patch) =>
    call(`/api/admin/sections/${id}`, { method: "PATCH", body: JSON.stringify(patch) }),
  deleteSection: (id) =>
    call(`/api/admin/sections/${id}`, { method: "DELETE" }),
  reorderSections: (ids) =>
    call("/api/admin/sections/reorder", { method: "POST", body: JSON.stringify({ ids }) }),

  // works
  createWork: ({ section_id, meta, file }) => {
    const form = new FormData();
    form.append("meta", JSON.stringify({ section_id, ...meta }));
    if (file) form.append("image", file);
    return call("/api/admin/works", { method: "POST", body: form });
  },
  patchWork: (id, patch, file) => {
    if (file) {
      const form = new FormData();
      form.append("meta", JSON.stringify(patch));
      form.append("image", file);
      return call(`/api/admin/works/${id}`, { method: "PATCH", body: form });
    }
    return call(`/api/admin/works/${id}`, { method: "PATCH", body: JSON.stringify(patch) });
  },
  deleteWork: (id) =>
    call(`/api/admin/works/${id}`, { method: "DELETE" }),
  reorderWorks: (section_id, ids) =>
    call("/api/admin/works/reorder", { method: "POST", body: JSON.stringify({ section_id, ids }) }),

  // settings
  setBio: (bio) =>
    call("/api/admin/bio", { method: "PUT", body: JSON.stringify(bio) }),
  setContact: (contact) =>
    call("/api/admin/contact", { method: "PUT", body: JSON.stringify(contact) }),
  setFeatured: (work_id) =>
    call("/api/admin/featured", { method: "PUT", body: JSON.stringify({ work_id }) }),
  setTweaks: (tweaks) =>
    call("/api/admin/tweaks", { method: "PUT", body: JSON.stringify(tweaks) }),
};

export function imageUrl(key) {
  return `/api/images/${key}`;
}

export const PAPER_PALETTES = [
  ["#a99878", "#7a6a4f"],
  ["#5e7066", "#3c4a43"],
  ["#8a6a5c", "#5d433a"],
  ["#bba27a", "#7e6a4b"],
  ["#4a5d76", "#2e3b4d"],
  ["#a37a8a", "#6d4f5c"],
  ["#5b6a4f", "#3a4534"],
  ["#c4a08a", "#8a6f5e"],
  ["#7a8a96", "#4e5b66"],
  ["#9a8a6a", "#6c5f48"],
];

export function slugify(s) {
  return String(s || "").toLowerCase().trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 60) || "section";
}
